// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimAdditionalFailureInfo, {getDefaultState as getClaimAdditionalFailureInfoDefaultState} from './claim-additional-failure-info';
import ClaimComplaintCause, {getDefaultState as getClaimComplaintCauseDefaultState} from './claim-complaint-cause';
import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimUseAmount, {getDefaultState as getClaimUseAmountDefaultState} from './claim-use-amount';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimItemPart from './claim-item-part';
import ClaimLabor from './claim-item-labor';
import ClaimOtherCredit from './claim-item-other-credit';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimPart = t.struct({
    additionalFailureInfo: ClaimAdditionalFailureInfo,
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    complaintCauseCommentsBasis: ClaimComplaintCause,
    customerSummary: CustomerSummary,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failureInfo: ClaimFailureInfo,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    installedBy: KeyValuePair,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    labor: t.maybe(t.list(ClaimLabor, 'Labor')),
    lifeTime: t.Bool,
    merchandizeItem: t.Bool,
    model: t.String,
    otherCredits: t.maybe(t.list(ClaimOtherCredit, 'OtherCredits')),
    partUseAmount: ClaimUseAmount,
    parts: t.maybe(t.list(ClaimItemPart, 'Parts')),
    pin: t.String,
    previousInvoiceNumber: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    retailInstallDate: t.maybe(t.Number),
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    serialNumber: t.String,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    showValidate: t.Bool,
    useAmounts: t.list(ClaimUseAmount, 'UseAmounts'),
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimPart',
    strict: true
});

export const getDefaultState = () => new ClaimPart({
    additionalFailureInfo: getClaimAdditionalFailureInfoDefaultState(),
    allowedActions: [
        {
            actionName: 'DRAFT',
            id: 'DRAFT',
            mode: 'CHG'
        }
    ],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: {
        key: 'ZPAR',
        value: ''
    },
    claimValueDetails: getClaimValueDetailsDefaultState(),
    complaintCauseCommentsBasis: getClaimComplaintCauseDefaultState(),
    customerSummary: getCustomerSummaryDefaultState(),
    errors: [],
    failureInfo: getClaimFailureInfoDefaultState(),
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    installedBy: getKeyValuePairDefaultState(),
    isDuplicateClaim: false,
    isEditable: true,
    labor: [],
    lifeTime: false,
    merchandizeItem: false,
    model: '',
    otherCredits: [],
    partUseAmount: getClaimUseAmountDefaultState(),
    parts: [],
    pin: '',
    previousInvoiceNumber: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    retailInstallDate: null,
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    serialNumber: '',
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    showValidate: true,
    useAmounts: [],
    validationFailed: false,
    version: ''
});

ClaimPart.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimPart.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimPart.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimPart;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-part.js